export enum OpportunityReferralTypeEnum {
  SHARED = 'Shared',
  INDEPENDENT = 'Independent',
}
